function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext, useEffect, useState } from "react";
import { SkeletonText, Tag } from "@carbon/react";
import { idContext } from "../../table-context";
import api from "./AppConfigApi";
export default function ConfigurePropertyDisplayValue(_ref) {
  var property = _ref.property;
  var id = useContext(idContext);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    resolved = _useState2[0],
    setResolved = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var appConfigString = property.value;
  var displayValue = appConfigString && appConfigString.substring(appConfigString.indexOf(".") + 1).replace("}", "");
  var tooltip = property.value || "";
  function fetchData() {
    setIsLoading(true);
    api.getAppConfigResolvedVal({
      appConfigString: appConfigString,
      envId: id.envId,
      toolchainId: id.toolchainId
    }).then(function (result) {
      if (result !== null && result !== void 0 && result.body) {
        var _result$body$resolved;
        var resolvedValue = (_result$body$resolved = result.body.resolved) === null || _result$body$resolved === void 0 || (_result$body$resolved = _result$body$resolved[0]) === null || _result$body$resolved === void 0 ? void 0 : _result$body$resolved.value;
        setResolved(resolvedValue);
      }
    })["finally"](function () {
      setIsLoading(false);
    });
  }
  useEffect(function () {
    fetchData();
  }, [property]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SkeletonText, {
      width: "50%"
    });
  }
  if (resolved !== null && resolved !== undefined) {
    return /*#__PURE__*/React.createElement("span", {
      className: "property-display-value-wrapper"
    }, /*#__PURE__*/React.createElement(Tag, {
      className: "ocr--appconfig-display-value",
      "data-type": property.type,
      title: tooltip,
      type: "teal"
    }, resolved.toString()));
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "property-display-value-wrapper"
  }, /*#__PURE__*/React.createElement(Tag, {
    className: "ocr--appconfig-display-value",
    "data-type": property.type,
    title: tooltip,
    type: "teal"
  }, displayValue));
}